import type { StaffUser } from "./api";

/**
 * Staff profile for this tab only, filled from GET /auth/staff/me.
 * Route checks in admin.ts read it when a caller omits the staff argument.
 * Nothing here is written to localStorage.
 */
let staff: StaffUser | null = null;

/** True after this tab has loaded a staff user. Does not read localStorage. */
export function hasStoredSession(): boolean {
  return staff !== null;
}

export function getStaffUser(): StaffUser | null {
  return staff;
}

export function setStoredStaff(next: StaffUser): void {
  staff = next;
}

export function updateStoredStaff(updates: Partial<StaffUser>): void {
  if (!staff) return;
  staff = { ...staff, ...updates };
}

export function clearStoredStaff(): void {
  staff = null;
}

export function clearSession(): void {
  staff = null;
}
